import React from "react";
import { useMedia } from "use-media";
import logo from "../../resources_catalog/icons/ico_catalog.svg";
import { useHistory } from "react-router-dom";
import { useStore } from "react-redux";
import bottom_arrow from "../../resources_catalog/icons/ico_bottom_arrow.svg";
import ico_inquiry from "../../resources_catalog/icons/ico_inquiry.svg";
import CatalogHeaderMenuPc from '../../catalogHeaderMenuPc';


export const CatalogHeaderContainerPc = (props) => {
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const isWideTablet = useMedia({ maxWidth: "960px" });
  const history = useHistory();
  const store = useStore();
  const onClickBack = () => {
    history.push(props.path);
  }
  const onClickReserve = () => {
    store.dispatch({ type: "RTCC_FLG", payload: { rtccFlg: true } });
    history.push("/reserve/rtcc/reservation");
  }
  return (
    <div className="catalogHeaderWrap">
      <div className="catalogHeader">
        <div className="catalogHeaderLogo">
          <img src={logo} alt="" onClick={onClickBack}/>
        </div>
        <div className="catalogHeaderMenuWrap">
          <CatalogHeaderMenuPc 
            onClick={onClickReserve}
          />
        </div>
      </div>
    </div>
  );
};

